import * as React from 'react'

/** Where the shell has put the brand and the account: floating in the header below `lg`, or
 *  in the ink column from `lg` (wide, or narrowed to its icons). The same two nodes render in
 *  every place and must answer differently, so a context and not a prop. */
export type ShellRegion = 'header' | 'column' | 'collapsed-column'

export const ShellRegionContext = React.createContext<ShellRegion>('header')

/** Whether the shell floats a header over the top of the page: below `lg`, and wherever no column
 *  stands. A hero that opens a page reads it, to keep its contents clear of the controls. */
export const ShellHeaderContext = React.createContext(false)

export function useShellHeader(): boolean {
  return React.useContext(ShellHeaderContext)
}

/** The two places in that header a page may put its own controls (`InHeader`): the start, for
 *  its way back, and the end, for its actions, beside the account. `null` where no header floats,
 *  and until the header has mounted. */
export const ShellHeaderStartContext = React.createContext<HTMLElement | null>(null)
export const ShellHeaderEndContext = React.createContext<HTMLElement | null>(null)

/** The click handler of a panel that must not outlive the destination it was opened to pick.
 *  A router navigates without unmounting it, so the new page would arrive behind it, and the
 *  link is the only signal available here: this package never imports the router. */
export function closeOnFollowedLink(close: () => void) {
  return (event: React.MouseEvent<HTMLElement>) => {
    if ((event.target as HTMLElement).closest('a') !== null) close()
  }
}
